const DEFAULT_OVER_PERFORMANCE_LIMIT = 200;

export { DEFAULT_OVER_PERFORMANCE_LIMIT };
